import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=4c893c9e&"
import script from "./FieldSelector.vue?vue&type=script&lang=js&"
export * from "./FieldSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c893c9e')) {
      api.createRecord('4c893c9e', component.options)
    } else {
      api.reload('4c893c9e', component.options)
    }
    module.hot.accept("./FieldSelector.vue?vue&type=template&id=4c893c9e&", function () {
      api.rerender('4c893c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/HotelBatchLoader/Components/FieldSelector.vue"
export default component.exports